import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConnectionService } from '@services/connection-service';
import { EventLoggerService } from '@services/event-logger-service';
import SwiperCore, { SwiperOptions, EffectFade } from 'swiper';

import { AppConfig } from '../app.config';

SwiperCore.use([EffectFade]);

@Component({
  selector: 'introduction',
  templateUrl: './introduction.html',
  standalone: false,
})
export class IntroductionComponent {
  public readonly conn: ConnectionService = inject(ConnectionService);
  private readonly appConfig: AppConfig = inject(AppConfig);
  private readonly dom: DomSanitizer = inject(DomSanitizer);
  private readonly eventLogger: EventLoggerService = inject(EventLoggerService);
  ui: any = { loading: true };
  showBtn: boolean = false;
  language: any;
  url: SafeResourceUrl;
  carouselConfig: SwiperOptions = {
    slidesPerView: 1,
    pagination: { el: '.swiper-pagination' },
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: true,
    autoplay: {
      delay: 4000, // 4 seconds delay
      disableOnInteraction: false, // Allow autoplay even when manually interacting with Swiper
    },
  };
  endOfSlide: boolean = false;
  currentSlide: number = 0;

  constructor() {
    this.language = this.conn.currentWebSiteLanguage.toLowerCase();
  }

  ngOnInit(): any {
    this.url = this.dom.bypassSecurityTrustResourceUrl(this.getVideoUrl());
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'onboarding-introduction' }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
  }

  getVideoUrl(): any {
    let videoURL = this.appConfig.Shared.IntroductionVideos[this.conn.currentWebSiteLanguage];
    if (!videoURL) videoURL = this.appConfig.Shared.IntroductionVideos[this.appConfig.Shared.Languages.EN];
    return videoURL;
  }

  load(): void {
    setTimeout((): void => {
      this.ui.loading = false;
      setTimeout((): boolean => this.showBtn = true, 9000);
    }, 500);
  }

  getStarted(): any {
    switch (this.currentSlide) {
      case 0: this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'introSliderSkip1' }));
        break;
      case 1: this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'introSliderSkip2' }));
        break;
      case 2: this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'introSliderContinue' }));
        break;
      default: break;
    }

    this.conn.navigateToURL('/onboarding/number');
  }
}
